import { createSlice } from "@reduxjs/toolkit";

const initialState={
    homeProducts:[],
    productDetails:null,
    productTypes:[],
    productTypeDetails:[],
    productFilterDetails:{
        priceFilteredProducts:[],
        productsTypeNames:[],
    },
    reviewDetails:{
        averageRating:0,
        totalNumberOfReview:0
    },
    allReviews:[],
    productId:null,
    loading:false,
    error:false
}

const productSlice=createSlice({
    name:'product',
    initialState, 
    reducers:{
        setLoading:(state,action)=>{
            state.loading=action.payload
        },
        setHomeProducts:(state,action)=>{
            state.homeProducts=action.payload
        },
        setProductDetails:(state,action)=>{
            state.productDetails=action.payload
        },
        setProductTypes:(state,action)=>{

            state.productTypes=action.payload
        },
        setTypedProductDetails:(state,action)=>{
            state.productTypeDetails=action.payload
        },
        setPriceFilteredProducts:(state,action)=>{
            console.log('ac',action.payload)
            state.productFilterDetails = {
                priceFilteredProducts: action.payload.priceFilteredProducts|| state.productFilterDetails.priceFilteredProducts,
                productsTypeNames: action.payload.productsTypeNames || state.productFilterDetails.productsTypeNames,
              };
            },
            setProductId:(state,action)=>{
                state.productId=action.payload
            },
            setReviewDetails:(state,action)=>{
                state.reviewDetails={
                    averageRating: action.payload.averageRating || 0, // Default to 0 if not provided
    totalNumberOfReview: action.payload.totalNumberOfReview || 0, // Default to 0 if not provided
  };
            },
            setAllReviews:(state,action)=>{
                state.allReviews=action.payload
            }
    }
})

export const {setHomeProducts,setProductDetails,setLoading,setProductTypes,setTypedProductDetails,setPriceFilteredProducts,setProductTypesInFilter,setProductId,setReviewDetails,setAllReviews}=productSlice.actions;

export default productSlice.reducer;